import React from 'react';
import { useOutletContext } from 'react-router-dom';
import OrgBilling from '../../components/OrgBilling';
import CheckoutIntent from '../../components/CheckoutIntent';
import { useEntityDoc } from '../../data/entities';
import CostsCard from './CostsCard';
import BudgetRequests from './BudgetRequests';

const USAGE_LABELS = {
  pipelineRuns: 'Pipeline runs',
  gatedCommits: 'Gated commits',
  hitlCycles: 'Human review cycles',
  jobRuns: 'Other jobs',
  workloadRuns: 'Compute workloads',
  devspaceLaunches: 'Dev space launches',
  streamBlockLaunches: 'Streaming block launches',
  aiTurns: 'Copilot turns',
};

// Same recipe as the pricing card: run 2, gated commit 2, HITL 1,
// conversation 10. Event counters stay the ledger; this is their sum.
function runtimeCredits(counters) {
  return (counters.pipelineRuns || 0) * 2
    + (counters.gatedCommits || 0) * 2
    + (counters.hitlCycles || 0) * 1
    + (counters.agentConversations || 0) * 10;
}

export default function BillingModule() {
  const { org, myRole } = useOutletContext();
  return (
    <div data-nova-note="Settings: plan and billing (Stripe checkout, seats, runtime credits), budget requests and this month's metered usage. Money-moving controls are the person's clicks; NoVA explains the plan and the usage rows.">
      <h1 style={{ margin: 0 }}>Settings <span className="mf-muted" style={{ fontWeight: 400, fontSize: 16 }}>· plan and billing</span></h1>
      <CheckoutIntent />
      <OrgBilling org={org} myRole={myRole} />
      <BudgetRequests org={org} myRole={myRole} />
      <CostsCard org={org} myRole={myRole} />
      <UsageSection orgId={org.id} />
    </div>
  );
}

// This month's metered usage — written server-side by the workers
// (shared/billing/usage.js), one doc per org per month.
function UsageSection({ orgId }) {
  const period = new Date().toISOString().slice(0, 7); // YYYY-MM (UTC)
  const { doc: usage } = useEntityDoc('usage', { org: orgId }, period);
  const counters = usage?.counters || {};
  const credits = runtimeCredits(counters);
  const rows = Object.entries(USAGE_LABELS)
    .map(([key, label]) => [label, counters[key] || 0])
    .filter(([, n]) => n > 0);
  if (credits > 0) rows.unshift(['Runtime credits', credits]);

  return (
    <section style={{ marginTop: 28 }}>
      <h2 style={{ margin: 0 }}>Usage · {period}</h2>
      {!rows.length && <div className="cs-empty" style={{ marginTop: 10 }}>No metered usage this month.</div>}
      <div style={{ display: 'grid', gap: 6, marginTop: 12, maxWidth: 420 }}>
        {rows.map(([label, n]) => (
          <div key={label} className="cs-card" style={{ padding: '10px 14px', display: 'flex' }}>
            <span>{label}</span>
            <span style={{ flex: 1 }} />
            <strong>{n}</strong>
          </div>
        ))}
      </div>
    </section>
  );
}
